var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48828 12.9167L10.1846 17.1524C10.6283 17.4823 11.2554 17.3896 11.5847 16.9454L19.5123 6.25",
    stroke: "#4F6FFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48828 12.9167L10.1846 17.1524C10.6283 17.4823 11.2554 17.3896 11.5847 16.9454L19.5123 6.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48828 12.9167L10.1846 17.1524C10.6283 17.4823 11.2554 17.3896 11.5847 16.9454L19.5123 6.25",
    stroke: "#7C7B7B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconGrey);
export default __webpack_public_path__ + "static/media/tick-icon-grey.bf18d5580bac8c80113dc5c0514e258b.svg";
export { ForwardRef as ReactComponent };